// extracted by mini-css-extract-plugin
export default {"ToolbarDiv":"CustomerGeneral_ToolbarDiv__H3bqz","DeleteButton":"CustomerGeneral_DeleteButton__DM1ir"};